module.exports = __webpack_public_path__ + "static/media/rejected.2f62e44b.svg";